export default function Computer (props) {

    return (
        <svg className={props.className} shapeRendering="geometricPrecision" style={props.style} fill={props.fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 56">
            <path d="M 0 40 L 0 4 Q 0 0 4 0 L 66 0 Q 70 0 70 4 L 70 40 Q 70 44 66 44 L 39 44 L 39 48 Q 39 50 41 50 L 48 50 Q 50 50 50 52 L 50 54 Q 50 56 48 56 L 24 56 Q 22 56 22 54 L 22 52 Q 22 50 24 50 L 31 50 Q 33 50 33 48 L 33 44 L 4 44 Q 0 44 0 40 M 6 36 Q 6 38 8 38 L 62 38 Q 64 38 64 36 L 64 8 Q 64 6 62 6 L 8 6 Q 6 6 6 8"/>
        </svg>
    )

}